import PropTypes from "prop-types";
import React from "react";
// Importiamo entrambi i file JSON
import featureIconData from "../../data/feature-icons/feature-icon.json";
import featureIconSpotData from "../../data/feature-icons/feature-icon-spot.json";
import FeatureIconSingle from "../../components/feature-icon/FeatureIconSingle";

const FeatureIcon = ({ spaceTopClass, spaceBottomClass }) => {
  // Se global.aziendaID è uguale a 3, usiamo i dati di "spot", altrimenti quelli di default
  const currentFeatureData = global.aziendaID === 3 ? featureIconSpotData : featureIconData;

  return (
    <div
      className={`support-area ${spaceTopClass ? spaceTopClass : ""} ${spaceBottomClass ? spaceBottomClass : ""
        }`}
    >
      <div className="container" style={{ width: "100%" }}>
        <div className="row">
          {/* Mappiamo i dati scelti dinamicamente */}
          {currentFeatureData.map(singleFeature => {
            return (
              <FeatureIconSingle
                singleFeature={singleFeature}
                key={singleFeature.id}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

FeatureIcon.propTypes = {
  spaceBottomClass: PropTypes.string,
  spaceTopClass: PropTypes.string
};

export default FeatureIcon;